<template>
  <div class="bg-blog max-w-main">
    <div class="p-1 relative" style="background: rgba(244, 244, 233, 0.60); height: 45px;" >
        <img class="ml-8 h-8 absolute z-50" @click="toHomePage" src="../../assets/logo_web.png" >
    </div>
    <div class="mt-4 p-3 color-main">
        <div class="color-main2 font-bold">
            <b-breadcrumb>
                <b-breadcrumb-item @click="$router.push(home_page)" >Trang chủ</b-breadcrumb-item>
                <b-breadcrumb-item @click="$router.push(blog_page)">Blog</b-breadcrumb-item>
                <b-breadcrumb-item active>Tài chính cá nhân</b-breadcrumb-item>
            </b-breadcrumb>
        </div>
        <div style="font-size: 24px;" class="font-bold">
            {{data.name}}
        </div>

        <div class=" grid grid-cols-2 mt-2">
            <div class="color-main2 font-bold ">
                <span class="text-border"> {{ data.category_name }} </span>
            </div>
            <div class="text-right font-bold text-sm">
                {{ data.created_time | toHMDMY }}
            </div>
        </div>

        <div class="content-detail text-black mt-4">
            <div v-html="data.content"></div>
        </div>

        <div class="tag">
            <div class="font-bold color-main2 text-border mt-3">
                TAGS
            </div>
            <div class="mt-2">
                <span class="text-white bg-main ml-3 rounded-md pl-2 pr-2 font-bold pt-1 pb-1 text-xs" v-for="(i) in data.tags"
                        :key="i">
                    <span class="active-btn category-btn main-center pd-5 mgt-10">
                        {{ i }}
                    </span>
                    <!-- <span @click="changeCategory(index,i.id)" v-else class="category-btn main-center content-box-app pd-5 mgt-10">
                        {{ i }}
                    </span> -->
                </span>
            </div>
        </div>

        <div class="mt-4" style="border-top: 1px solid #EBECED; color: white; height: 1px;">.</div>

        <div class="mt-4">
            <div class="font-bold text-2xl">
                BÀI VIẾT MỚI
            </div>
            <div>
                <div class="mgt-10" v-for="item in news" :key="item.id">
                    <!-- <b-row>
                        <b-col :cols="3">
                            <img style="border-radius: 5px;" width="72" height="72" :src="item.image" >
                        </b-col>
                        <b-col style="padding-left: 0px;vertical-align: middle; height: 72px;">
                            <div style="vertical-align: middle;height: 72px;" class="fw-700 ft-16">
                                {{item.name}}
                            </div>
                        </b-col>
                    </b-row> -->

                    <div @click="viewDetail(item.id,item.slug)" class=" grid grid-cols-12 mt-2">
                        <div class="color-main2 col-span-3 font-bold ">
                            <img style="border-radius: 5px;" width="72" height="72" :src="item.image" >
                        </div>
                        <div class="text-left font-bold col-span-9 text-sm" style="padding-left: 0px;vertical-align: middle; height: 72px;">
                            <div style="vertical-align: middle;height: 72px;" class="fw-700 ft-16">
                                {{item.name}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="mgt-20">
            <div class="font-bold text-2xl">
                Bài viết liên quan
            </div>
            <div>
                <div class="mgt-10" v-for="item in refer" :key="item.id">
                    <div @click="viewDetail(item.id,item.slug)" class=" grid grid-cols-12 mt-2">
                        <div class="color-main2 col-span-3 font-bold ">
                            <img style="border-radius: 5px;" width="72" height="72" :src="item.image" >
                        </div>
                        <div class="text-left font-bold col-span-9 text-sm" style="padding-left: 0px;vertical-align: middle; height: 72px;">
                            <div style="vertical-align: middle;height: 72px;" class="fw-700 ft-16">
                                {{item.name}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    </div>

  </div>
</template>

<script>
import { getDetailBlog,getNewBlog,getReferenceBlog } from '@/api/otp'
import subRoute from '@/router/subRoute'

export default {
    components: { },
    data(){
        return{
            total: 100,
            currentPage: 1,
            data: {},
            tags: ['Tài chính','Vay tiền'],
            news: [],
            refer: [],
            items: [
            {
                text: 'Trang chủ',
                href: '#'
            },
            {
                text: 'Blog',
                href: '#'
            },
            {
                text: 'Tài chính cá nhân',
                active: true
            }
            ],
            c_active: 0,
            title_: '.',
            meta_: '',
            meta_description: '',
            meta_key: '',
            meta_tag: '',
            meta_title: '',
            home_page: subRoute,
            blog_page: subRoute + 'blog'
        }
    },
    methods: {
        clickToBread(e){
            console.log(e)
        },
        viewDetail(id,slug){
            let r = subRoute + 'blog/chi-tiet/' +id +'/'+slug
            this.$router.push(r)
        },
        toHomePage(){
            let r = subRoute
            this.$router.push(r)
        },
        fetchData(){
            getDetailBlog({id: this.$route.params.id}).then(res => {
                this.data = res.data
                this.title_ = res.data.name
                // this.meta_title = res.data.meta_title
                // this.meta_description = res.data.meta_description
                // this.meta_key = res.data.meta_key
                // this.meta_tag = res.data.meta_tag

                this.meta_ = [
                    { name: 'title', content:  res.data.meta_title },
                    { name: 'description', content: res.data.meta_description },
                    { name: 'key', content: res.data.meta_key },
                    { name: 'tag', content: res.data.meta_tag }
                ]
                //console.log(this.title_)
                this.$emit('updateHead')
            })
        },
        fetchNews(){
            getNewBlog({id: this.$route.params.id}).then(res => {
                this.news = res.data
            })
        },
        fetchRe(){
            getReferenceBlog({id: this.$route.params.id}).then(res => {
                this.refer = res.data
            })
        }
    },
    created(){
        this.fetchData()
        this.fetchNews()
        this.fetchRe()

        // this.$on('okHead', function () {
        //     this.fetchData()
        // });
    },
    head: {
        title(){
            return {
                inner: this.title_,
            }
        },
        meta: function () {
            return this.meta_
        }
    }
}
</script>

<style>
.breadcrumb {
    --bs-breadcrumb-padding-x: 0;
    --bs-breadcrumb-padding-y: 0;
    --bs-breadcrumb-margin-bottom: 1rem;
    --bs-breadcrumb-bg: ;
    --bs-breadcrumb-border-radius: ;
    --bs-breadcrumb-divider-color: #f1674a;
    --bs-breadcrumb-item-padding-x: 0.5rem;
    --bs-breadcrumb-item-active-color: #862d99;
    display: flex;
    flex-wrap: wrap;
    padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);
    margin-bottom: var(--bs-breadcrumb-margin-bottom);
    font-size: var(--bs-breadcrumb-font-size);
    list-style: none;
    background-color: var(--bs-breadcrumb-bg);
    border-radius: var(--bs-breadcrumb-border-radius);
}
.bc-detail a {
    color: black;
}
.page-link {
    position: relative;
    display: block;
    padding: 0.5rem 0.75rem;
    color: black;
    margin-left: 5px;
    background-color: #fff;
    border: 1px solid #dee2e6;
    border-radius: 8px !important;
    min-width: 33.8px;
}

.page-item.active .page-link {
    z-index: 3;
    color: #F1674A;
    background-color: #FEF0ED;
    border-color: #F1674A;
}
.content-detail img {
    max-width: 100%;
    height: auto;
}
</style>